<template>
  <div ref="home" class="home-page">
    <el-carousel height="100%" :autoplay="true" :interval="33000">
      <el-carousel-item v-for="(item, key) in banner" :key="key">
        <div class="home-slider-1">
          <video v-if="item.video_mode && item.video_url && item.video_url !== ''" autoplay="autoplay" loop="loop" :src="item.video_url" muted :poster="item.img" type="video/mp4">
          </video>
          <div v-else-if="item.img" class="img" :style="{backgroundImage: `url(${item.img})`}"></div>
          <div class="inner">
            <div>
              <h2>{{item.title}}</h2>
              <h3>{{item.sub_title}}</h3>
              <h4>{{item.desc}}</h4>
              <a v-if="item.link && item.link != ''" :href="item.link">了解更多</a>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="home-slider-2">
      <video autoplay="autoplay" loop="loop" src="@/assets/an1-18.mp4" muted poster="@/assets/an1-19.jpg" type="video/mp4">
      </video>
      <div
        class="inner"
        :style="`transform: scale(${scaleRatio});margin:${mgTop} 0 0 ${mgLeft}`"
      >
        <ul class="top">
          <li><b>规划服务</b></li>
          <li><b>项目实施</b></li>
          <li><b>运行维护</b></li>
          <li><b>运营提升</b></li>
          <li><b>碳排控制</b></li>
        </ul>
        <ul class="bottom">
          <li><b>立足电力行业</b></li>
          <li><b>联动多方资源</b></li>
          <li><b>赋能产业生态</b></li>
          <li><b>推动绿色发展</b></li>
        </ul>
        <ul class="gear">
          <li><span>智慧运营</span></li>
          <li><span>绿电低碳</span></li>
          <li><span>智能产品</span></li>
          <li><span>智电设计</span></li>
          <li><span>智能配网</span></li>
        </ul>
      </div>
    </div>
    <div class="home-slider-3">
      <busi 
        :style="`transform: scale(${scaleRatio4});margin:${mgTop3} 0 0 ${mgLeft}`"
      />
    </div>
    <div class="home-slider-4">
      <news 
        :style="`transform: scale(${scaleRatio4});margin:${mgTop4} 0 0 ${mgLeft}`"
      />
      <div class="footer">
        Copyright © 北京九州恒盛电力科技有限公司All Rights Reserved, 京ICP备16016567号-1
      </div>
    </div>
    <div class="mouse">
      <i></i>
      <b>向下滑动<br/>探索更多</b>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Carousel, CarouselItem } from "element-ui";
import News from "./news.vue";
import Busi from "./busi.vue";
export default {
  name: "App",
  components: {
    ElCarousel: Carousel,
    ElCarouselItem: CarouselItem,
    Busi,
    News,
  },
  data() {
    return {
      banner: [],
      scaleHeight: '100%',
      scaleRatio: 1,
      aniLeft: '0',
      mgLeft: '0',
      mgTop: '0',
      moving: false,
      timer: null,
      allheight: 0,
      pageH: 0,
      curPage: 0,
      speed: 1,
      scaleRatio4: 1,
      mgTop3: '0',
      mgTop4: '0',
      lastScrollTime: 0,
      lastWheel: 0,
      touchS: 0
    };
  },
  mounted() {
    window.onresize = this.setScale;
    this.setScale();
    this.bind();
    const tab =  this.$route.params.tab
    const vm = this
    if (typeof tab !== 'undefined') {
      this.goStage(Number(tab))
    }
    this.getData()
    window.addEventListener('touchstart',function setHasTouch(e){
      vm.touchS = e.pageY
      // window.removeEventListener('touchstart', setHasTouch);
    });
    window.addEventListener('touchend',function setHasTouch(e){
      if (e.pageY - vm.touchS > 50) {
        vm.goPage('down');
      }
      if (vm.touchS - e.pageY > 50) {
        vm.goPage('up');
      }
    });
  },
  methods: {
    getData() {
      axios.get('/api/v1/article/banner').then(r => {
        if (r && r.data && r.data.length)
        this.banner = r.data
      })
    },
    setScale() {
      const w = document.body.clientWidth;
      const h = document.body.clientHeight - (w > 1280 ? 80 : 60);
      this.scaleRatio = h / w >= 0.62 ? w / 1280 : h / 794;
      this.scaleRatio *= 0.8;
      this.scaleRatio4 = h / w >= 0.5 ? w / 1280 : h / 700
      this.scaleRatio4 *= 0.85;
      this.mgTop = (h - 794) / 2 + "px";
      this.mgTop3 = (h - 670) / 2 + "px";
      this.mgTop4 = (h - 650) / 2 + "px";
      this.mgLeft = (w - 1280) / 2 + "px";
      this.pageH = h;
      this.allheight = this.pageH * 4;
    },
    scrollFunc(e) {
      e = e || window.event;
      // 如果数字是变大则重新执行
      // console.log(e.wheelDelta, this.lastWheel)
      // if (this.moving || (Math.abs(e.wheelDelta) - 10) < Math.abs(this.lastWheel)) {
      if (this.moving || e.timeStamp - this.lastScrollTime < 200) {
        this.lastScrollTime = e.timeStamp
        // this.lastWheel = e.wheelDelta
        return;
      } else {
        // console.log('go')
        var current = this.$refs.home.scrollTop;
        if (e.wheelDelta > 0 || e.detail < 0) {
          if (current == 0) {
            return;
          }
          this.goPage('down');
        }
        if (e.wheelDelta < 0 || e.detail > 0) {
          if (current >= this.allheight - this.pageH) {
            return;
          }
          this.goPage('up');
        }
      }
      this.lastScrollTime = e.timeStamp
    },
    goPage(d) {
      const vm = this
      if (vm.moving) {
        return false
      }
      vm.moving = true;
      let nextPage = d === 'up' ? vm.curPage + 1 : vm.curPage - 1
      nextPage = nextPage > 3 ? 3 : nextPage < 0 ? 0 : nextPage
      const des = nextPage * vm.pageH
      if (!vm.timer) {
        vm.timer = setInterval(function () {
          var cur = Math.round(vm.$refs.home.scrollTop);
          let tar = d === 'up' ? cur + vm.speed : cur - vm.speed
          console.log(tar, d, des)
          if (d === 'up' && tar > des || d === 'down' && tar < des) {
            tar = des
          }
          vm.$refs.home.scrollTo(0, tar);
          if (d === 'down'){
            if (cur > des - vm.pageH / 2) {
              vm.speed++;
            } else {
              vm.speed--;
            }
          } else {
            if (cur < des + vm.pageH / 2) {
              vm.speed++;
            } else {
              vm.speed--;
            }
          }
          if (d === 'down' && cur <= des || d === 'up' && cur + 2 >= des) {
            clearInterval(vm.timer)
            vm.timer = null
            vm.speed = 1
            vm.curPage = nextPage
            vm.$refs.home.scrollTo(0, des);
            vm.moving = false;
            vm.$router.push('/Home/' + vm.curPage)
          }
        }, 15);
      }
    },
    goStage(n) {
      const des = n * this.pageH
      this.$refs.home.scrollTo(0, des);
      this.curPage = n
    },
    keyUp(e) {
      if (e.keyCode === 38) {
        this.goPage('down');
      } else if (e.keyCode === 40) {
        this.goPage('up');
      }
    },
    bind() {
      if (document.addEventListener) {
        document.addEventListener("wheel", this.scrollFunc, false);
        document.addEventListener('keyup', this.keyUp);
      }
      // window.onmousewheel = document.onmousewheel = this.scrollFunc;
    },
    unbind() {
      if (document.removeEventListener) {
        document.removeEventListener("wheel", this.scrollFunc, false);
        document.removeEventListener("keyup", this.keyUp, false);
      }
      // window.onmousewheel = document.onmousewheel = null
    }
  },
  destroyed() {
    this.unbind()
    if (document.removeEventListener) {
        document.removeEventListener("resize", this.setScale);
    }
  }
};
</script>
